<template>
  <div class="container success-container mt-12 mt-lg-6">
    <div class="container text-center mt-2">
      <img class="logo" :src="logoSvg" />
    </div>
    <div class="container row text-center mt-0 pt-0 ml-1 pr-10">
      <v-col cols="12 text-center mt-3">
        <img src='@/assets/thankYouIcone.svg' />
      </v-col>
    </div>
    <div class="container mt-0 mb-0 pb-0">
      <p cols="12" class="pl-4 base-info-description">{{ $t('thankYouDescription') }}</p>
    </div>
    <div class="container mt-0">
      <v-col cols="12" lg="12" class="text-center">
        <button
          @click="goToDocuments"
          class="main-button-gradient main-button-gradient-full-width semibold-font"
        >
          <span>{{ $t('done') }}</span>
          <button class="checked-mark-icon ml-2 inline-grid"></button>
        </button>
      </v-col>
    </div>
    <div class="container mt-0 mb-0 pb-0 pt-0 mt-0">
      <v-col class="mt-0 mb-2 pt-0 pb-0" cols="12" sm="12">
        <v-row class="mt-6">
          <v-col cols="2" class="mt-2">
            <span><img src='@/assets/icons/i-icon.svg' /></span>
          </v-col>
          <v-col cols="10" class="info-text">
            <span>{{ $t('thankYouInfo') }}</span>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DocumentRedirect',
  computed: {
    ...mapGetters(['currentClient']),

    logoSvg () {
      if (this.$i18n.locale === 'ro' || location.host.includes('.ro')) {
        return require('@/assets/euro-tax.ro.svg')
      } else if (this.$i18n.locale === 'bg' || location.host.includes('.bg')) {
        return require('@/assets/euro-tax.bg.svg')
      } else if (location.host.includes('.euro-tax.pl')) {
        if (this.$i18n.locale === 'ro') {
          return require('@/assets/euro-tax.ro.svg')
        } else if (this.$i18n.locale === 'bg') {
          return require('@/assets/euro-tax.bg.svg')
        } else {
          return require('@/assets/euro-tax.pl.svg')
        }
      } else {
        return require('@/assets/cuf-logo.svg')
      }
    }
  },
  methods: {
    goToDocuments () {
      this.$router.push('/documents')
    }
  }
}
</script>

<style lang="scss" scoped>
.success-container {
  min-height: 500px;
  border-radius: 20px !important;
  opacity: 1;
  background: linear-gradient(white, white) padding-box,
            linear-gradient(to right, #F57921, #D20F6E) border-box !important;
  border: 2px solid transparent !important;
}

.inline-grid {
  display: inline-grid;
  margin-top: 0px;
  margin-left: -13px;
  position: absolute;
}
</style>
